import Controller, { OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { FetchAPI, ModalAPI } from '@philips-internal/oswald-ui-components';
import ResultTermServiceAPI from '@philips-emr/referring-physician-components/lib/components/result-term-service/result-term-service-api';
import { AuthenticationService, HttpService, JWTToken } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import TokenConstants from '../../constants/TokenConstants';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

interface Privacy {
  termSeqNr: number;
}

@Controller({ fragment: 'assign-privacy-modal', component: 'assign-privacy-modal' })
export default class AssignPrivacyModalController extends BaseController {

  @Inject('privacy-fetch')
  fetchTermoUso: FetchAPI;

  @Inject('newaccount.link.privacy')
  checkTerm: ResultTermServiceAPI;

  @Inject('assign-privacy-modal')
  modal: ModalAPI;

  @OnMount({ target: ['assign-privacy-modal'] })
  onMount(): void {
    this.checkPrivacy();
    this.modal.setCloseable(true);
    const { privacySeqNr } = this.historyService.getCurrentRouteParams() as Record<string,string>;
    this.context.set({ privacySeqNr });
    const nrSeqValid = privacySeqNr !== 'undefined';
    this.checkTerm.setEnabled(nrSeqValid);
    if (nrSeqValid) {
      this.fetchTermoUso.forceFetch();
    }
  }

  checkPrivacy(): void {
    HttpService.get(APPLICATION_ENDPOINTS.CHECK_PRIVACY).then((result) => {
      const privacy = result.body as Privacy;
      if (privacy.termSeqNr) {
        AuthenticationService.logout();
      }
    });
  }

  @OnClose({ target: ['assign-privacy-modal'] })
  onclose(): void {
    const { privacySeqNr } = this.historyService.getCurrentRouteParams();

    if (privacySeqNr !== 'undefined') {
      HttpService.put(APPLICATION_ENDPOINTS.UPDATE_PRIVACY, { privacySeqNr }).then(() => {
        const token = AuthenticationService.getJWTToken() as JWTToken;
        const cdPhysicalPerson: string = token.claims[TokenConstants.CD_PHYSICAL_PERSON] as string;
        const params = { cdPhysicalPerson };
        this.historyService.push(APPLICATION_ROUTES.EXAMS_RESULTS, params);
      });
    }
  }
}
